import intlTelInput from 'intl-tel-input';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import '../signup_form.scss';
import '../signup_card.scss';
import { FormattedMessage } from 'react-intl';
import { getErrorMessage } from '../../../utils/errorMessage';
import { sendPhoneNumber } from '../../signup.api';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

type Props = Partial<RouteComponentProps> & {
  saveAndGetToNextStep: Function;
  children: React.ReactNode;
  source: string;
  sourcePage: string;
};

type State = {
  phoneNumber: string;
  error: string;
  isSubmitting: boolean;
};

export class SignUpAskPhoneContent extends React.Component<Props, State> {
  static defaultProps = {
    children: null,
    source: 'signup-phone-modal',
    sourcePage: '',
    history: null,
  };

  state: State = {
    phoneNumber: '',
    error: '',
    isSubmitting: false,
  };

  componentDidMount() {
    if (this.input) {
      this.iti = intlTelInput(this.input, {
        customPlaceholder: (selectedCountryPlaceholder, data) => {
          if (data.iso2 === 'fr') return 'Ex. 06 55 55 55 55';
          return `Ex. ${selectedCountryPlaceholder}`;
        },
        nationalMode: true,
        preferredCountries: ['fr'],
        utilsScript: '/static_js/vendor/utils.js',
      });
      // eventListener needed for asynchronous js function intlTelInput (deletion to replace by onChange in input leads to signup fail)
      this.input.addEventListener('change', this.handleChange);
    }
  }

  componentWillUnmount() {
    if (this.input) this.input.removeEventListener('change', this.handleChange);
  }

  sendPhoneNumber = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    try {
      const { phoneNumber } = this.state;
      const phoneNumberCleaned = phoneNumber.replace(/\s/g, '');
      await sendPhoneNumber(phoneNumberCleaned);
      doctrineAnalytics('Account SignUpAskPhoneValidated', {
        source: this.props.source,
        sourcePage: this.props.sourcePage,
      });
      this.setState({ isSubmitting: false });
      this.props.saveAndGetToNextStep(phoneNumberCleaned);
    } catch (error) {
      this.setState({ isSubmitting: false });
      if (error.response === 'BYPASS_PHONE_VERIFICATION') {
        // automatically validated because Esendex downtime is simulated
        if (this.props.history) {
          this.props.history.push('/');
        }
      } else if (error.response && error.response.data) {
        if (error.response.data.error === 'PHONE_NUMBER_ALREADY_USED') {
          doctrineAnalytics('Account SignUpPhoneAlreadyUsed', {
            source: this.props.source,
            sourcePage: this.props.sourcePage,
          });
        }
        doctrineAnalytics('Account SignUpAskPhoneError', {
          error: error.response.data.error,
          source: this.props.source,
          sourcePage: this.props.sourcePage,
        });
        this.setState({
          error: getErrorMessage(error.response),
        });
      } else {
        throw error;
      }
    }
  };

  handleChange = () => {
    const phoneNumber = this.iti.getNumber();
    this.setState({ phoneNumber, error: '' });
  };

  input: HTMLInputElement | null = null;

  iti: any;

  render() {
    const { isSubmitting, error } = this.state;
    return (
      <>
        <i className="material-icons icons__phone_iphone signup-card__icon" />
        <div className="signup-card__title">
          <FormattedMessage id="signup/routes/ask-phone/SignUpAskPhoneContent.tsx/1" />
        </div>
        <div className="signup-card__subtitle">
          <FormattedMessage id="signup/routes/ask-phone/SignUpAskPhoneContent.tsx/2" />
          {'\u00a0'}
          <FormattedMessage id="signup/routes/ask-phone/SignUpAskPhoneContent.tsx/3" />
        </div>
        <form onSubmit={this.sendPhoneNumber}>
          <div className="signup-form__label">
            <FormattedMessage id="signup/routes/ask-phone/SignUpAskPhoneContent.tsx/4" />
          </div>
          <div className="signup-form__phone">
            <input
              ref={ref => {
                this.input = ref;
              }}
              className="signup-form__phone__input"
              id="phone"
              type="tel"
            />
          </div>
          {error && (
            <div className="form-error is-visible signup-form__error">
              {error}
            </div>
          )}
          <button
            type="submit"
            className="button brand large expanded"
            disabled={isSubmitting}
          >
            <FormattedMessage id="signup/routes/ask-phone/SignUpAskPhoneContent.tsx/5" />
          </button>
        </form>
        {this.props.children}
      </>
    );
  }
}
